export default __webpack_public_path__ + "static/media/nftimg3.3d9036f2.png";